import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';

import { I18nContextProvider } from '@ecg-internal/js-react-i18n';
import { Header } from '@hz-design-system/web-ui';

import { trackGAEvent } from '../../utils/gaTracking';
import CategoryMenuBarApp from '../../apps/CategoryMenuBar/CategoryMenuBar';
import Autospage from '../../apps/Autospage';

import '../../../scss/global.scss';

const renderClientRoot = (root: HTMLElement | null, element: React.ReactNode) => {
  if (!root) {
    return;
  }

  if (root.hasChildNodes()) {
    hydrateRoot(root, element);
    return;
  }

  createRoot(root).render(element);
};

export default function autospage(i18n: any) {
  const appState = window.__CONFIG__ || {};
  const environment = window.__ENV_CONFIG__ || {};
  const headerConfig = window.__HEADER_CONFIG__ || {};
  const headerRoot = document.getElementById('header-root');
  const categoryMenuBarRoot = document.getElementById('category-menu-bar-root');
  const autosRoot = document.getElementById('autos-root');

  // Header is server side rendered in express-react library
  renderClientRoot(headerRoot, <Header headerConfig={headerConfig} trackGAEvent={trackGAEvent} />);

  renderClientRoot(
    categoryMenuBarRoot,
    <I18nContextProvider i18nInstance={i18n}>
      <CategoryMenuBarApp appState={appState} environment={environment} />
    </I18nContextProvider>,
  );

  renderClientRoot(
    autosRoot,
    <I18nContextProvider i18nInstance={i18n}>
      <Autospage environment={environment} />
    </I18nContextProvider>,
  );
}
